export default __webpack_public_path__ + "static/media/sem-taxas.a6034d55.png";